import React, { useState, useEffect } from 'react'
import { Panel, Row, Col, ControlLabel, SelectPicker, Icon, IconButton } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../utils/loading'
// import MiniProjectInfo from './MiniProjectInfo'
import MiniProjectInfo from '../projectBasedItemsWidget/MiniProjectInfo'
import { useHistory } from 'react-router-dom'
import PdfRenderWidgets from '../pdfWidgets/PdfRenderWidgets'
import { isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import PreviewButton from '../../components/buttons/previewButton/PreviewButton'
import { downloadFile } from '../../utils/fileUtil'
import {
  downloadFinancialPdf,
  downloadFinancialExport,
} from '../../redux/actions/financialReportsDelivered'
import OverlayLoader from '../../components/OverlayLoader/OverlayLoader'
import notification from '../../utils/notification'

export default function FinancialReportsDeliveredWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState(props.schema)
  const [voucherSchema, setVoucherSchema] = useState()
  const [periodicSchema, setPeriodicSchema] = useState()
  const [isExpanded, setIsExpanded] = useState(true)
  const [previewPdf, setPreviewPdf] = useState()
  const [isLoadingPDF, setIsLoadingPDF] = useState(false)

  const projectCode = sessionStorage.getItem('projectCode')

  const onsubmitPreeviewFile = async (data) => {
    console.log('onsubmitPreeviewFile ', data)

    startLoading()
    setIsLoadingPDF(true)
    try {
      var file = await downloadFinancialPdf(projectCode, data.periodOption)
      setPreviewPdf(file)
      // previewFile(
      //   file,
      //   `${projectCode}_เอกสารรับรองการตรวจสอบเงินงวดโครงการ_งวดที่_${data.periodOption}`
      // )
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: 'ดาวน์โหลด ไม่สำเร็จ ',
        duration: 5000,
      })
    }
    setIsLoadingPDF(false)
    doneLoading()
  }

  const handleOnExport = async (data) => {
    console.log('handleOnExport ', data)

    setIsLoading(true)
    startLoading()
    try {
      const file = await downloadFinancialExport(projectCode, data.periodOption)
      console.log('file ', file)
      if (file) {
        downloadFile(file, `ข้อมูลรายงานการเงินนำส่ง.xlsx`)
      } else {
        notification.open('error', {
          title: 'ไม่สามารถทำรายการได้ กรุณาลองใหม่หรือติดต่อผู้ดูแลระบบ',
          duration: 5000,
        })
      }
    } catch (e) {
      console.log('handleExportFile error : ', e)
      notification.open('error', {
        title: e?.errors?.message || 'ไม่สามารถทำรายการได้ กรุณาลองใหม่หรือติดต่อผู้ดูแลระบบ',
        duration: 5000,
      })
    }
    setIsLoading(false)
    doneLoading()
  }

  return (
    <>
      <Panel
        shaded
        collapsible
        defaultExpanded
        header={' '}
        bordered
        expanded={isExpanded}
        onSelect={() => {
          setIsExpanded(!isExpanded)
          setVoucherSchema(null)
          setPeriodicSchema(null)
        }}
      >
        <MiniProjectInfo schema={formSchema?.projectInfo} />

        {isLoadingPDF && <OverlayLoader />}

        <br />

        {/* <Panel bordered> */}
        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24} style={{ textAlign: 'right' }}>
            <ControlLabel>
              {requiredFiled(
                formSchema.form.periodOption.validators,
                formSchema.form.periodOption.label
              )}
            </ControlLabel>
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <ErrorMessage error={errors[formSchema.form.periodOption.name]} />
            <Controller
              name={formSchema.form.periodOption.name}
              control={control}
              defaultValue={formSchema.form.periodOption.value}
              rules={isValidators(formSchema.form.periodOption.validators)}
              render={(props) => {
                return (
                  <SelectPicker
                    searchable={false}
                    data={formSchema.form.periodOption.options}
                    value={props.value}
                    block
                    placeholder={formSchema?.form?.periodOption?.placeholder || ''}
                    onChange={(value) => {
                      props.onChange(value)
                    }}
                  />
                )
              }}
            />
          </Col>
          <Col lg={4} md={4} sm={24} xs={24}>
            {/* <h5>{formSchema.form.period.label}</h5> */}
          </Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            {/* <h5>{formSchema.form.period.value || ''}</h5> */}
          </Col>
        </Row>

        <Row style={{ marginTop: 10 }}>
          <Col lg={4} md={4} sm={24} xs={24}></Col>
          <Col lg={8} md={8} sm={24} xs={24}>
            <PreviewButton onClick={handleSubmit(onsubmitPreeviewFile)} />

            <IconButton
              appearance="ghost"
              icon={<Icon icon="file-excel-o" className="bt-gost-icon-radius" />}
              onClick={handleSubmit(handleOnExport)}
              style={{ marginBottom: 10 }}
            >
              Export to MS-Excel
            </IconButton>
          </Col>
        </Row>

        {previewPdf && (
          <Row style={{ marginTop: 30 }}>
            <PdfRenderWidgets
              file={previewPdf}
              isLoading={isLoadingPDF}
              isShaded={false}
              onReload={handleSubmit(onsubmitPreeviewFile)}
              loadingMessage="กรุณารอสักครู่ ระบบกำลังสร้าง PDF รายงานการเงินนำส่ง..."
            />
          </Row>
        )}
      </Panel>
      {/* </Panel> */}
    </>
  )
}
